<template>
  <section
    v-editable="blok"
    :class="`article-quote--${blok.size} theme-light article-quote ${animationClass}`"
  >
    <div class="container">
      <div class="row">
        <div :class="`article-quote__content ${getClassNames(blok.size)}`">
          <blockquote v-if="blok.copy" class="article-quote__copy">
            {{ blok.copy }}
          </blockquote>
          <div
            v-if="blok.citation_1 && !blok.citation_2"
            class="article-quote__citation"
          >
            {{ blok.citation_1 }}
          </div>
          <div
            v-if="blok.citation_1 && blok.citation_2"
            class="article-quote__citation"
          >
            {{ blok.citation_1 }}
            <span class="article-quote__citation-divider">/</span>
            {{ blok.citation_2 }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ArticleQuote',
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: () => false,
    },
    animateWhenVisible: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      animationClass: 'article-quote--animate',
      isAnimationActive: true,
    }
  },
  watch: {
    visible(visible) {
      if (visible && this.isAnimationActive) {
        this.animationClass =
          ' article-quote--animate article-quote--animate-done'
        this.isAnimationActive = false
      }
    },
  },
  mounted() {
    if (this.animateWhenVisible) {
      this.animationClass = ' article-quote--animate'
    }
  },
  methods: {
    getClassNames: (align) => {
      if (align === 'small') {
        return 'col-12 col-md-9 col-lg-6'
      }
      return 'col-12'
    },
  },
}
</script>

<style lang="scss">
@import '../../../assets/scss/settings';

.article-quote {
  padding-top: spacer(3);
  padding-bottom: spacer(3);

  &--animate {
    .article-quote__citation,
    .article-quote__copy {
      opacity: 0;
      transform: translate(0, 30px);
      transition: all 0.6s cubic-bezier(0.7, 0, 0.3, 1) 0.1s;
    }
    .article-quote__citation {
      transition: all 0.6s cubic-bezier(0.7, 0, 0.3, 1) 0.15s;
    }
  }
  &--animate-done {
    .article-quote__citation,
    .article-quote__copy {
      opacity: 1;
      transform: translate(0, 0);
    }
  }

  &__content {
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: spacer(3);
    padding-right: spacer(3);
  }

  &__citation {
    @include font-size(12);

    width: calc(100% - 76.5px);

    &-divider {
      padding: 0 spacer(1);
    }
  }

  blockquote {
    @include font-size(16, rem-v(28));
    @include font-family($font-family-headings-bold, $headings-font-weight);

    position: relative;

    &::before {
      @include font-family($font-family-headings-bold, $font-weight-bold);
      @include font-size(60, rem-v(28));

      content: '“';
      left: -40px;
      position: absolute;
      top: 10px;
    }

    &::after {
      @include font-family($font-family-headings-bold, $font-weight-bold);
      @include font-size(60, rem-v(28));

      content: '”';
      position: relative;
      top: 9px;
      left: 7px;
      vertical-align: middle;
    }
  }

  &--small {
    .article-quote__citation {
      margin-top: spacer(1);
    }
    .article-quote__content {
      margin-right: auto;
      margin-left: auto;
    }

    &::before {
      @include font-size(60, rem-v(72));

      top: 0;
    }

    &::after {
      @include font-size(60, rem-v(72));

      top: 20px;
      left: 0;
    }
  }

  &--large {
    blockquote {
      @include font-size(60, rem-v(72));

      &::before {
        @include font-size(60, rem-v(72));

        top: 0;
      }

      &::after {
        @include font-size(60, rem-v(72));

        top: 20px;
        left: 0;
      }
    }
  }
}
</style>
